import Heading from "../heading/Heading";

export default function AboutMe() {
    return (
        <div className="space-y-4">
            <div><Heading title="ABOUT ME" isPageTop={true} /></div>
            <div className="space-y-4 text-primary aboutme-section">
                <p>
                    A hands on CTO, architect, dba and developer with 20+ years of
                    experience across startups, scale-ups, and enterprise projects.
                </p>
                <p>
                    Able to own delivery from concept to production, with a proven track record of delivering high quality, robust, scalable and maintainable solutions.
                </p>
                <p> </p>
                <p>
                    Proven ability to lead teams, optimise systems, build lighting fast data solutions for huge data volumes, and deliver
                    impactful results in diverse industries, including Energy Trading, Insurance, IoT, SaaS,
                    Marketing, Public Sector.
                </p>
            </div>
        </div>
    );
}








